/** YouTube channel connect for a granted client (social module, flag social.youtube; 404 feature_disabled while off). */
import type { YouTubeAccountView, YouTubeChannelOption } from '@qm/contracts/social';
import { seg, type Http } from '../kit/http';

export interface YouTubeCallbackView { tenantId: string; pendingId: string | null; channels: YouTubeChannelOption[]; reconnected: boolean; connected: YouTubeAccountView[] }

export function youtubeApi(http: Http) {
  return {
    accounts: (tenantId: string) => http.get<YouTubeAccountView[]>(`/v1/social/agency/clients/${seg(tenantId)}/youtube/accounts`),
    start: (tenantId: string, reconnectAccountId?: string) =>
      http.post<{ authorizeUrl: string; state: string }>(`/v1/social/agency/clients/${seg(tenantId)}/youtube/oauth/start`, reconnectAccountId ? { reconnectAccountId } : {}),
    callback: (state: string, code: string) => http.post<YouTubeCallbackView>('/v1/social/agency/youtube/oauth/callback', { state, code }),
    select: (pendingId: string, channelIds: string[]) => http.post<{ tenantId: string; connected: YouTubeAccountView[] }>('/v1/social/agency/youtube/oauth/select', { pendingId, channelIds }),
    disconnect: (tenantId: string, id: string) => http.post<{ id: string; status: string }>(`/v1/social/agency/clients/${seg(tenantId)}/youtube/accounts/${seg(id)}/disconnect`, {}),
  };
}
